module.exports = __webpack_public_path__ + "img/cog-turn.1a80c80f.png";